/**
 * @description returns false ONLY if value is null or undefined
 * - zero will return true
 * - empty string will also return true
 * - The "value i string | number" is a type guard that ensures the value is either string | number when the function returns true
 */
export const exists = (value: string | number | null | undefined | unknown): value is string | number => value != null

/**
 * @description returns true ONLY if value is a string and not empty ("")
 * - null/undefined will return false
 * - empty string will return false
 * - number will return false
 */
export const stringExists = (value: string | null | undefined | unknown): value is string => !!value && value !== '' && typeof value === 'string'
